<template>
  <div class="page-box">
    <el-form
      :model="form"
      ref="form"
      :rules="rules"
      label-width="auto"
      :inline="false"
    >
      <el-form-item label="规则名称:" prop="ruleName">
        <el-input v-model="form.ruleName"></el-input>
      </el-form-item>
      <el-form-item label="所属组别分类:" prop="groupClassifyId">
        <el-select v-model="form.groupClassifyId" placeholder="请选择" style="width: 100%;">
            <el-option v-for="item in groupClassifyList" :key="item.id" :label="item.classifyName" :value="item.id">
            </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="限报次数:" prop="limitItemTimes">
        <el-input v-model.number="form.limitItemTimes"></el-input>
        <div style="font-size: 12px;color:#01A7F0;">项数只能大于或等于0；为0表示不受限制</div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { queryDropdownSelectGroupClassifies, saveLimitSignupRule } from '../../../../../api/mymatchs/groupsetitem';


export default {
  name: "add-group-rule",
  data() {
    return {
      form: {
        ruleName:'',
        limitItemTimes: 0,
        groupClassifyId:""
      },
      rules: {
        ruleName:[{ required: true, message: "请输入限报规则名称", trigger: "blur" }],
        groupClassifyId:[{ required: true, message: "请选择组别", trigger: "blur" }],
        limitItemTimes: [
          { required: true, message: "请输入限报次数", trigger: "blur" },
          {validator: (rule,value,callback) => {
            if(value < 0) {
              callback(new Error('项数只能大于或等于0；为0表示不受限制'));
            }
            callback()
          }, trigger: 'blur'}
        ],
      },
      matchId:'',
      groupClassifyList:[]
    };
  },
  created() {
    const { row ,matchId} = this.$attrs.params;
    if(row) {
      this.form = {
        id:row.id,
        ruleName:row.ruleName,
        limitItemTimes: row.limitItemTimes,
        groupClassifyId:row.groupClassifyId,
      }
    }
    if(matchId) {
      this.matchId = matchId;
      this.getGroupClassifyList();
    }
  },
  methods: {
    confirm(callback,close) {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const res = await saveLimitSignupRule({matchId: this.matchId,...this.form});
          if(res && res.status == 200){
            this.$message.success("保存成功");
            callback();
            close()
          }else{
            res && res.msg && this.$message.error(res.msg);
          }
        } else {
          return false;
        }
      });
    },
    async getGroupClassifyList() {
      const params = {
        matchId: this.$attrs.params.matchId,
      }
      const res = await queryDropdownSelectGroupClassifies(params);
      if(res && res.status == 200) {
        this.groupClassifyList = res.data;
        if(this.form.id){
          const { row:{groupClassifyName} } = this.$attrs.params
          this.groupClassifyList.push({id:this.form.groupClassifyId,classifyName:groupClassifyName})
        }
      } else {
        res && res.msg && this.$message.error(res.msg);
      }

    },
  },
};
</script>
<style lang="scss" scoped>
.page-box {
  padding: 15px;
}
</style>
